var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKmzNetwork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8069_14021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75471 8.45284H8.15094V13.8868H8.75471V8.45284Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1003 2.02451L13.6733 1.59758L9.14512 6.1258L9.57205 6.55272L14.1003 2.02451Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.7925 8.33318L7.36557 7.90625L1.59859 13.6732L2.02552 14.1002L7.7925 8.33318Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.45862 5.82419L4.13797 2.50354L3.71104 2.93047L7.03169 6.25112L7.45862 5.82419Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7984 12.1634L9.58255 7.94753L9.15562 8.37445L13.3715 12.5903L13.7984 12.1634Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4906 3.01887C15.3242 3.01887 16 2.34307 16 1.50943C16 0.675797 15.3242 0 14.4906 0C13.6569 0 12.9811 0.675797 12.9811 1.50943C12.9811 2.34307 13.6569 3.01887 14.4906 3.01887Z",
    fill: "#BD1D23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45282 16C9.28646 16 9.96226 15.3242 9.96226 14.4906C9.96226 13.6569 9.28646 12.9811 8.45282 12.9811C7.61919 12.9811 6.94339 13.6569 6.94339 14.4906C6.94339 15.3242 7.61919 16 8.45282 16Z",
    fill: "#BD1D23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.50943 15.3962C2.34307 15.3962 3.01887 14.7204 3.01887 13.8868C3.01887 13.0532 2.34307 12.3774 1.50943 12.3774C0.675797 12.3774 0 13.0532 0 13.8868C0 14.7204 0.675797 15.3962 1.50943 15.3962Z",
    fill: "#BD1D23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.62264 3.32075C4.12282 3.32075 4.5283 2.91527 4.5283 2.41509C4.5283 1.91491 4.12282 1.50943 3.62264 1.50943C3.12246 1.50943 2.71698 1.91491 2.71698 2.41509C2.71698 2.91527 3.12246 3.32075 3.62264 3.32075Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.283 12.9811C13.7832 12.9811 14.1887 12.5757 14.1887 12.0755C14.1887 11.5753 13.7832 11.1698 13.283 11.1698C12.7828 11.1698 12.3773 11.5753 12.3773 12.0755C12.3773 12.5757 12.7828 12.9811 13.283 12.9811Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45291 5.13208C9.61997 5.13212 10.5662 6.07829 10.5662 7.24536C10.5662 8.4124 9.61995 9.3586 8.45291 9.35864C7.28584 9.35864 6.33967 8.41242 6.33963 7.24536C6.33963 6.07827 7.28582 5.13208 8.45291 5.13208ZM8.45291 6.03833C7.78606 6.03833 7.24499 6.57853 7.2449 7.24536C7.2449 7.91227 7.786 8.45337 8.45291 8.45337C9.11969 8.45321 9.65994 7.91217 9.65994 7.24536C9.65985 6.57863 9.11963 6.03849 8.45291 6.03833Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8069_14021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKmzNetwork);
export default __webpack_public_path__ + "static/media/kmzNetwork.c07697ba88e84cec49ac5caca61f4073.svg";
export { ForwardRef as ReactComponent };